module.exports = {"430124001":"玉潭街道","430124002":"白马桥街道","430124003":"历经铺街道","430124004":"城郊街道","430124101":"道林镇","430124102":"花明楼镇","430124103":"东湖塘镇","430124104":"夏铎铺镇","430124105":"双江口镇","430124106":"煤炭坝镇","430124107":"坝塘镇","430124109":"灰汤镇","430124110":"双凫铺镇","430124111":"老粮仓镇","430124112":"流沙河镇","430124113":"巷子口镇","430124114":"龙田镇","430124116":"横市镇","430124117":"回龙铺镇","430124118":"黄材镇","430124119":"大成桥镇","430124120":"青山桥镇","430124121":"金洲镇","430124122":"大屯营镇","430124123":"资福镇","430124203":"菁华铺乡","430124209":"喻家坳乡","430124213":"沙田乡","430124218":"沩山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430124.json
// module id = 1935
// module chunks = 0